"use client";
import { LogInCarousel } from "@/components/frontend-components/LogInCarousel";
import { Inter } from "next/font/google";
import { useEffect, useState } from "react";


export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <div className="bg-cover bg-center" style={{ backgroundImage: `url('/login_background.png')`}}>
      <div
        className={`flex items-center justify-center`}
      >
        {children}
      </div>
    </div>
  );
}
